import React from "react";
import PlayIcon from "@material-ui/icons/PlayArrow";
import PauseIcon from "@material-ui/icons/Pause";

interface Props {
  videoRef: React.MutableRefObject<HTMLVideoElement | null>;
  buttonStyles: string;
}

const PlayPauseButton = ({ videoRef, buttonStyles }: Props) => {
  const playPauseVideo = () => {
    try {
      if (!videoRef.current) {
        throw new Error("Required video data is missing.");
      }
      const video = videoRef.current;
      if (video.paused || video.ended) {
        video.play();
      } else {
        video.pause();
      }
    } catch (error) {
      console.error(error);
    }
  };

  return (
    <button id="playpause" className={buttonStyles} type="button" onClick={playPauseVideo}>
      {videoRef.current !== null && !videoRef.current.paused && !videoRef.current.ended ? (
        <PauseIcon />
      ) : (
        <PlayIcon />
      )}
    </button>
  );
};

export default PlayPauseButton;
